import { FiTrash2 } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";

const ButtonDelete = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "red",
    className: `lg:h-10 lg:w-10 h-[38px] w-[38px] rounded-[6px] ${props.className}`,
  };
  return (
    <Button {...tmpProps}>
      <FiTrash2 size={20} />
      {props.children}
    </Button>
  );
};

export default ButtonDelete;
